var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 7.99899C21.9999 7.82052 21.9519 7.64535 21.8612 7.49166C21.7705 7.33798 21.6402 7.21137 21.4841 7.12499L12.4621 2.12499C12.3138 2.04332 12.1473 2.00049 11.9781 2.00049C11.8088 2.00049 11.6423 2.04332 11.4941 2.12499L2.51607 7.08499C2.3601 7.17136 2.23006 7.29785 2.13941 7.45136C2.04876 7.60487 2.0008 7.77983 2.00049 7.95811C2.00018 8.13639 2.04754 8.31151 2.13767 8.46534C2.22779 8.61916 2.3574 8.7461 2.51307 8.83299L11.5351 13.873C11.6836 13.9564 11.8511 14.0004 12.0214 14.0005C12.1918 14.0007 12.3594 13.9571 12.5081 13.874L21.4861 8.87399C21.642 8.78727 21.7719 8.6604 21.8623 8.50654C21.9527 8.35268 22.0002 8.17744 22.0001 7.99899ZM12.0231 11.854L5.06007 7.96499L11.9771 4.14299L18.9411 8.00199L12.0231 11.854Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.515 11.126L12 15.856L3.48504 11.126L2.51404 12.874L11.514 17.874C11.6626 17.9565 11.8296 17.9997 11.9995 17.9997C12.1694 17.9997 12.3365 17.9565 12.485 17.874L21.485 12.874L20.515 11.126Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.515 15.126L12 19.856L3.48504 15.126L2.51404 16.874L11.514 21.874C11.6626 21.9565 11.8296 21.9997 11.9995 21.9997C12.1694 21.9997 12.3365 21.9565 12.485 21.874L21.485 16.874L20.515 15.126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.7874c86e344e6094c28ee99df04cb591.svg";
export { ForwardRef as ReactComponent };